import type { ComponentType, SVGProps } from 'react';

import {
  BallIcon,
  CalendarIcon,
  ClipboardIcon,
  CrystalIcon,
  HomeIcon,
  ListIcon,
  ReverseIcon,
  SettingsIcon,
  ShieldIcon,
  TrophyIcon,
  UsersIcon,
  WalletIcon,
} from '../icons';

export interface NavItem {
  to: string;
  label: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  /** Only match the exact path — used for index routes. */
  end?: boolean;
}

/** TZ §30 — the player's five primary destinations, sized for a tab bar. */
export const PLAYER_NAV: readonly NavItem[] = [
  { to: '/', label: 'Главная', icon: HomeIcon, end: true },
  { to: '/rounds', label: 'Розыгрыши', icon: TrophyIcon },
  { to: '/rounds/rating', label: 'Рейтинг', icon: ClipboardIcon },
  { to: '/matches', label: 'Матчи', icon: BallIcon },
  { to: '/predictions', label: 'Прогнозы', icon: ListIcon },
  { to: '/balance', label: 'Баланс', icon: WalletIcon },
  { to: '/settings', label: 'Профиль', icon: SettingsIcon },
];

/** TZ §40 — admin panel sections available to every administrator. */
export const ADMIN_NAV: readonly NavItem[] = [
  { to: '/admin', label: 'Дашборд', icon: HomeIcon, end: true },
  { to: '/admin/rounds', label: 'Розыгрыши', icon: TrophyIcon },
  { to: '/admin/rounds/rating', label: 'Общий рейтинг', icon: ClipboardIcon },
  { to: '/admin/matches', label: 'Матчи', icon: CalendarIcon },
  { to: '/admin/teams', label: 'Команды', icon: BallIcon },
  { to: '/admin/players', label: 'Игроки', icon: UsersIcon },
  { to: '/admin/finance', label: 'Кристаллы', icon: CrystalIcon },
];

/** TZ §40 — SuperAdministrator-only sections. */
export const SUPER_ADMIN_NAV: readonly NavItem[] = [
  { to: '/admin/administrators', label: 'Администраторы', icon: ShieldIcon },
  { to: '/admin/settings', label: 'Настройки', icon: SettingsIcon },
  { to: '/admin/audit-log', label: 'Журнал действий', icon: ClipboardIcon },
  { to: '/admin/reversals', label: 'Сторнирования', icon: ReverseIcon },
  { to: '/admin/platform-ledger', label: 'Касса платформы', icon: WalletIcon },
];
